var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72496 9.72511C9.43246 9.43261 9.43246 8.96011 9.72496 8.66761L12.6275 5.75011H1.24996C0.837461 5.75011 0.49996 5.41261 0.49996 5.00011C0.49996 4.58761 0.837461 4.25011 1.24996 4.25011H12.6275L9.71746 1.34011C9.42496 1.04761 9.42496 0.575107 9.71746 0.282607C10.01 -0.00989258 10.4825 -0.00989258 10.775 0.282607L14.975 4.47511C15.2675 4.76761 15.2675 5.24011 14.975 5.53261L10.7825 9.72511C10.49 10.0101 10.01 10.0101 9.72496 9.72511Z",
    fill: "#727981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.bc6c4ef3.svg";
export { ForwardRef as ReactComponent };